import { getTempToken } from '@/api'
import decode from 'jwt-decode'
import { PublicCheckoutStepKeys, publicCheckoutSteps } from './steps'

type CategoryId = 'LI' | 'CO' | 'LE' | 'FL' | 'CY'

interface StepKey {
  key: keyof typeof PublicCheckoutStepKeys
  keyIndex: number
}

interface Messages {
  titles: Record<string, string>
  subtitles: Record<string, string>
  breadcrumbs: Record<string, string>
}

interface CheckoutStep {
  key: keyof typeof PublicCheckoutStepKeys
  keyIndex: number
  Component: React.ComponentType<any>
  title: string
  subtitle: string
  breadcrumbs: string
  tooltip?: string
}

export const getLocationIdFromToken = (): string => {
  const { location_id: locationId } = decode<{ location_id: string }>(
    getTempToken(),
  )
  return locationId
}

export const makeCheckoutSteps = (
  categoryId: CategoryId,
  messages: Messages,
  tooltips?: Record<string, string>,
): CheckoutStep[] => {
  let stepKeys: StepKey[] = []

  switch (categoryId) {
    case 'LI':
      stepKeys = [
        { key: PublicCheckoutStepKeys.startDate, keyIndex: 0 },
        { key: PublicCheckoutStepKeys.overview, keyIndex: 1 },
        { key: PublicCheckoutStepKeys.companyDetailsAndPayment, keyIndex: 2 },
        { key: PublicCheckoutStepKeys.killerQuestions, keyIndex: 3 },
        { key: PublicCheckoutStepKeys.poa, keyIndex: 3 },
      ]
      break
    case 'CO':
      stepKeys = [
        { key: PublicCheckoutStepKeys.startDate, keyIndex: 0 },
        { key: PublicCheckoutStepKeys.overview, keyIndex: 1 },
        { key: PublicCheckoutStepKeys.companyDetailsAndPayment, keyIndex: 2 },
        { key: PublicCheckoutStepKeys.killerQuestions, keyIndex: 3 },
        { key: PublicCheckoutStepKeys.poa, keyIndex: 3 },
      ]
      break
    case 'LE':
      stepKeys = [
        { key: PublicCheckoutStepKeys.overview, keyIndex: 1 },
        { key: PublicCheckoutStepKeys.companyDetailsAndPayment, keyIndex: 2 },
        { key: PublicCheckoutStepKeys.killerQuestions, keyIndex: 3 },
        { key: PublicCheckoutStepKeys.poa, keyIndex: 3 },
      ]
      break
    case 'FL':
      stepKeys = [
        { key: PublicCheckoutStepKeys.startDate, keyIndex: 0 },
        { key: PublicCheckoutStepKeys.overview, keyIndex: 1 },
        { key: PublicCheckoutStepKeys.companyDetailsAndPayment, keyIndex: 2 },
        { key: PublicCheckoutStepKeys.payment, keyIndex: 3 },
        { key: PublicCheckoutStepKeys.killerQuestions, keyIndex: 3 },
        { key: PublicCheckoutStepKeys.poa, keyIndex: 3 },
      ]
      break
    case 'CY':
      stepKeys = [
        { key: PublicCheckoutStepKeys.overview, keyIndex: 1 },
        { key: PublicCheckoutStepKeys.companyDetailsAndPayment, keyIndex: 2 },
        { key: PublicCheckoutStepKeys.killerQuestions, keyIndex: 3 },
        { key: PublicCheckoutStepKeys.poa, keyIndex: 3 },
      ]
      break
    default:
      stepKeys = [
        { key: PublicCheckoutStepKeys.startDate, keyIndex: 0 },
        { key: PublicCheckoutStepKeys.overview, keyIndex: 1 },
        { key: PublicCheckoutStepKeys.companyDetailsAndPayment, keyIndex: 2 },
        { key: PublicCheckoutStepKeys.poa, keyIndex: 3 },
      ]
  }

  return stepKeys.map(({ key, keyIndex }) => ({
    key,
    keyIndex,
    Component: publicCheckoutSteps[key],
    title: messages.titles[key],
    subtitle: messages.subtitles[key],
    breadcrumbs: messages.breadcrumbs[key],
    tooltip: tooltips?.[key],
  }))
}
